export default {
    user: {
        gpa: {},
        positions: [],
        sport: {
            id: "",
            name: "",
        },
        guardians: [],
    },

    hasRetrievedBasicInfo: false,
    isSendingFeedbackRequest: false,
    isTakingEvaluationAction: false,
    actionTimestamp: null,
    isModal: false,
    showNewAthleteProfile: false,
    showSecondaryNavbar: true,
    showMultiPlaylists: false,
    showIsolationEffects: false,
    videoPlaylists: [],
    skills: [],
    videoPlaylistPlaying: null,
    shareLinkVideo: null,
}